import { dialogTypes } from '@/dialogs'

export default {
  [dialogTypes.alert]: require('@/dialogs/alert').default,
  [dialogTypes.prompt]: require('@/dialogs/prompt').default,
  [dialogTypes.confirm]: require('@/dialogs/confirm').default,
  [dialogTypes.institutionSelection]: require('@/dialogs/institutionSelection').default,
  [dialogTypes.address]: require('@/dialogs/address').default,
  [dialogTypes.license]: require('@/dialogs/license').default,
  [dialogTypes.contactInformation]: require('@/dialogs/contactInformation').default,
  [dialogTypes.relatedInstitution]: require('@/dialogs/relatedInstitution').default,
  [dialogTypes.relatedPerson]: require('@/dialogs/relatedPerson').default,
  [dialogTypes.branch]: require('@/dialogs/branch').default,
  [dialogTypes.realEstate]: require('@/dialogs/realEstate').default,
  [dialogTypes.personalId]: require('@/dialogs/personalId').default,
  [dialogTypes.individualInCharge]: require('@/dialogs/individualInCharge').default,
  [dialogTypes.addDashboardWidget]: require('@/dialogs/addDashboardWidget').default,
  [dialogTypes.userRow]: require('@/dialogs/userRow/userRow').default,
  [dialogTypes.bankSelector]: require('@/dialogs/bankSelector').default,
  [dialogTypes.branchSelector]: require('@/dialogs/branchSelector').default,
  [dialogTypes.exportPdf]: require('@/dialogs/exportPdf').default,
  [dialogTypes.inputPassphrase]: require('@/dialogs/inputPassphrase').default,
  [dialogTypes.addUserRole]: require('@/dialogs/addUserRole').default,
  [dialogTypes.inputPatTokenName]: require('@/dialogs/inputPatTokenName').default,
  [dialogTypes.generatedPatToken]: require('@/dialogs/generatedPatToken').default,
  [dialogTypes.editPhoneNumber]: require('@/dialogs/editPhoneNumber').default,
  [dialogTypes.twoFactorAuthentication]: require('@/dialogs/twoFactorAuthentication/index').default,
  [dialogTypes.twoFactorSetup]: require('@/dialogs/twoFactorSetup/index').default,
  [dialogTypes.branchManagers]: require('@/dialogs/branchManagers').default,
  [dialogTypes.capitalOperation]: require('@/dialogs/capitalOperation').default,
  [dialogTypes.bankAccountNumber]: require('@/dialogs/bankAccountNumber').default,
  [dialogTypes.editLegacyCode]: require('@/dialogs/editLegacyCode').default,
  [dialogTypes.bgJobMessages]: require('@/dialogs/bgJobMessages').default,
  [dialogTypes.validationErrors]: require('@/dialogs/validationErrors').default
}



// WEBPACK FOOTER //
// ./src/report-app/dialogs.js